// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"8ca99424","214":"4ec58bb2","356":"3883ae66","411":"a2013c16","458":"7b60d19f","473":"2cff37ba","542":"3c5575ab","741":"b1a6f105","774":"0edbe482","787":"0f8d78ff","858":"641adef6"}[chunkId] + ".chunk.js";
};